// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/workflow.js';

import { paths } from '../generated/workflow';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('workflow', Original, paths);
